import React from "react";

import { Button, Card, Col, Container, Row } from "react-bootstrap";
import "react-image-gallery/styles/css/image-gallery.css";
import { NavLink } from "react-router-dom";

import { trackEvent } from "@/components/GA.component";
import { getUrlLangPrefix } from "@/utils/Local";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ScheduleComponent from "../components/Schedule.component";
import i18n from "../i18n";

const GalleryPage = () => {
  const { t } = i18n;

  const langPrefix = getUrlLangPrefix();
  const items = [
    {
      title: t("Events"),
      to: `${langPrefix}/${t("_route.events")}`,
      img: `https://cdn.pakville.ca/images/gallery/event-thumbnail2.jpg`,
      category: "events",
    },
    {
      title: t("Awards"),
      to: `${langPrefix}/${t("_route.awards")}`,
      img: `https://cdn.pakville.ca/images/gallery/awards-thumbnail.png`,
      category: "awards",
    },
  ];

  return (
    <React.Fragment>
      <DocumentComponent title={t("gallery")} />
      <BannerComponent
        description={t("gallery_description")}
        title={t("gallery")}
      />

      <Container className="min-vh-50">
        <Row>
          {items.map((item) => (
            <Col key={item.title} className="mb-3" lg={6} xs={12}>
              <NavLink
                to={item.to}
                onClick={() => {
                  trackEvent(`gallery_click`, {
                    category: item.category,
                  });
                }}
              >
                <Card className="h-100 shadow-lg border-0 p-3">
                  <Card.Img
                    alt={item.title}
                    className="rounded"
                    src={item.img}
                    variant="top"
                  />
                  <Card.Footer
                    className="p-0 mt-3 mb-1"
                    style={{ background: "unset", border: "unset" }}
                  >
                    <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2 w-100">
                      <span>{item.title}</span>
                    </Button>
                  </Card.Footer>
                </Card>
              </NavLink>
            </Col>
          ))}
        </Row>
      </Container>

      <ScheduleComponent />

      <br />
      <br />
      <br />
    </React.Fragment>
  );
};

export default GalleryPage;
